import { defineStore } from 'pinia'
import type { ApiInfoResponse } from '~/server/api/info'

type AddToCartData = {
  title: string
  productId: string
  ticketCategoryId: string
  price: number
  minQuantity?: number
  maxQuantity?: number
}

type SeatWidgetData = {
  product: Exclude<ApiInfoResponse['product'], undefined>
  quantity: number
  date: string
  time: string
  performanceId: string
  performanceExternalId: string
}

type State = {
  addToCart: AddToCartData | null
  seatWidget: SeatWidgetData | null
  isLoginModalOpen: boolean
  isRegisterModalOpen: boolean
  isForgotPasswordModalOpen: boolean
  isSearchModalOpen: boolean
  isAddToCartModalOpen: boolean
  isSeatWidgetModalOpen: boolean
  isSeatWidgetLtdModalOpen: boolean
  isShareModalOpen: boolean
  isContactUsModalOpen: boolean
}

export const useModalsStore = defineStore('modals', {
  state: (): State => ({
    addToCart: null,
    seatWidget: null,
    isLoginModalOpen: false,
    isRegisterModalOpen: false,
    isForgotPasswordModalOpen: false,
    isSearchModalOpen: false,
    isAddToCartModalOpen: false,
    isSeatWidgetModalOpen: false,
    isSeatWidgetLtdModalOpen: false,
    isShareModalOpen: false,
    isContactUsModalOpen: false,
  }),
  actions: {
    openLoginModal() {
      this.isLoginModalOpen = true
    },
    openContactUsModal() {
      this.isContactUsModalOpen = true
    },
    closeLoginModal() {
      this.isLoginModalOpen = false
    },
    openRegisterModal() {
      this.isRegisterModalOpen = true
    },
    closeRegisterModal() {
      this.isRegisterModalOpen = false
    },
    openForgotPasswordModal() {
      this.isForgotPasswordModalOpen = true
    },
    closeForgotPasswordModal() {
      this.isForgotPasswordModalOpen = false
    },
    openSearchModal() {
      this.isSearchModalOpen = true
    },
    closeSearchModal() {
      this.isSearchModalOpen = false
    },
    openAddToCartModal(data: AddToCartData) {
      this.addToCart = data
      this.isAddToCartModalOpen = true
    },
    closeAddToCartModal() {
      this.isAddToCartModalOpen = false
    },
    openSeatWidgetModal(data: SeatWidgetData) {
      this.seatWidget = data
      this.isSeatWidgetModalOpen = true
    },
    openSeatWidgetLtdModal(data: SeatWidgetData) {
      this.seatWidget = data
      this.isSeatWidgetLtdModalOpen = true
    },
    closeSeatWidgetModal() {
      this.isSeatWidgetModalOpen = false
    },
    closeSeatWidgetLtdModal() {
      this.seatWidget = null
      this.isSeatWidgetLtdModalOpen = false
    },
    openShareModal() {
      this.isShareModalOpen = true
    },
    closeShareModal() {
      this.isShareModalOpen = false
    },
    closeContactUsModal() {
      this.isContactUsModalOpen = false
    },
  },
})
